import axios from 'axios';

import { useQuery } from 'react-query';

export default function useGetIdCardsEquipmentList() {
  const { data, isFetching, error } = useQuery(
    ['idCardsEquipmentList'],
    async () => (await axios.get(`/idcards/equipment`)).data
  );

  return {
    equipmentList: data,
    isLoading: isFetching,
    error,
  };
}
